'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { center, flex } from '@onbeam/business-styled-system/patterns';
import { token } from '@onbeam/business-styled-system/tokens';
import { useBreakpoint } from '@onbeam/utils';
import { AnimatePresence, motion } from 'motion/react';
import { investingInSubjects } from './Hero.data';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export const HeroVideo = () => {
  const isSmallMobile = useBreakpoint({ max: token('breakpoints.sm') });
  const isMobile = useBreakpoint({ max: token('breakpoints.md') });
  const [activeQuoteIndex, setActiveQuoteIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveQuoteIndex(
        (prevIndex) => (prevIndex + 1) % investingInSubjects.length,
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const activeQuote = investingInSubjects[activeQuoteIndex];
  // const Icon = activeQuote?.icon;
  const iconSize = isSmallMobile ? 24 : isMobile ? 32 : 48;

  return (
    <div
      className={cx(
        'dark',
        center({
          position: 'relative',
          px: { base: '4', md: '5' },
          maxW: '[90rem]',
          w: 'full',
          h: '[33.75rem]',
          overflow: 'hidden',
        }),
      )}
    >
      <Image
        alt=""
        priority
        src="/images/hero-overlay.png"
        width={2048}
        height={1152}
        className={css({
          position: 'absolute',
          top: '[50%]',
          left: '[50%]',
          transform: 'translate(-50%, -50%)',
          h: { base: '[130%]', md: '[230%]' },
          objectFit: 'cover',
        })}
      />
      <video
        src="/videos/hero.mp4"
        autoPlay
        loop
        muted
        playsInline
        className={css({
          position: 'absolute',
          top: '[50%]',
          left: '[50%]',
          transform: 'translate(-50%, -50%)',
          h: 'full',
          w: 'full',
          objectFit: 'cover',
          mixBlendMode: 'overlay',
        })}
      />
      <div
        className={center({
          display: 'inline-flex',
          maxW: '[30rem]',
          whiteSpace: 'normal',
          textWrap: 'balance',
          lineHeight: 1.1,
          textAlign: 'center',
          zIndex: 10,
          color: 'mono.primaryBg',
          userSelect: 'none',
          textStyle: { base: 'body-lg', sm: 'body-xl', md: 'subtitle-lg' },
        })}
      >
        {/* <AnimatePresence mode="popLayout" initial={false}>
          <motion.span
            // TODO: On mobile, this initially animated upwards, which we do not want
            layout="position"
            transition={{
              ease: 'easeOut',
            }}
          >
            Investing in{' '}
          </motion.span>
          <motion.div
            initial={{
              opacity: 0,
              x: -30,
            }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            exit={{
              opacity: 0,
              x: 40,
            }}
            transition={{
              ease: 'easeOut',
            }}
            key={activeQuoteIndex}
            className={flex({
              ml: { base: '2', md: '3' },
              gap: { base: '2', md: '3' },
              alignItems: 'center',
            })}
            style={{
              height: iconSize,
            }}
          >
            {Icon && <Icon height={iconSize} width={iconSize} />}
            <span>{activeQuote.text}</span>
          </motion.div>
        </AnimatePresence> */}
        <AnimatePresence mode="popLayout" initial={false}>
          <motion.div
            initial={{
              opacity: 0,
              x: -30,
            }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            exit={{
              opacity: 0,
              x: 40,
            }}
            transition={{
              ease: 'easeOut',
            }}
            key={activeQuoteIndex}
            className={flex({
              ml: { base: '2', md: '3' },
              gap: { base: '2', md: '3' },
              alignItems: 'center',
            })}
            style={{
              height: iconSize,
            }}
          >
            <span>{activeQuote.text}</span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};
